// extracted by mini-css-extract-plugin
export default {"tableButton":"NotificationPage_tableButton__PET-U","tableButtonGold":"NotificationPage_tableButtonGold__2NXeu","tableButtonGreen":"NotificationPage_tableButtonGreen__rDwat"};